// src/features/alerts/utils/alertsUtils.js
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
/**
 * Determina el tipo de alerta basado en la diferencia de tiempo hasta la fecha de vencimiento
 * 
 * @param {string|Date} expirationDate - Fecha de vencimiento
 * @returns {string} Tipo de alerta (expired, critical, warning, etc.)
 */


export const getAlertType = (expirationDate) => {
  if (!expirationDate) return '';
  dayjs.extend(utc); 
  const timeDifference = dayjs(expirationDate).diff(dayjs(), 'seconds');
  
  if (timeDifference < 0) {
    return 'expired';
  } else if (timeDifference < 2629800) { // 30 días
    return 'critical';
  } else if (timeDifference < 5259600) { // 60 días
    return 'warning';
  } else if (timeDifference < 15552000) { // 180 días
    return 'ok_6_month';
  } else if (timeDifference < 31104000) { // 12 meses
    return 'ok_12_month';
  } else if (timeDifference < 47335500) { // 18 meses
    return 'ok_18_month';
  }
  
  return 'ok';
};

export const compareExpirationDates = (firstDate, secondDate) => {
  const first = dayjs(firstDate);
  const second = dayjs(secondDate);
  const firstIsValid = firstDate && first.isValid();
  const secondIsValid = secondDate && second.isValid();

  if (!firstIsValid && !secondIsValid) return 0;
  if (!firstIsValid) return 1;
  if (!secondIsValid) return -1;

  return first.valueOf() - second.valueOf();
};

/**
 * Obtiene el color de fondo basado en el tipo de alerta
 * 
 * @param {string} alertType - Tipo de alerta
 * @returns {object} Objeto de estilo con el color de fondo
 */
export const getAlertStyle = (alertType) => {
  switch (alertType) {
    case 'expired':
      return { backgroundColor: '#f44336' }; // Rojo 
    case 'critical':
      return { backgroundColor: '#ffab40' }; // Naranja 
    case 'warning':
      return { backgroundColor: '#ffea00' }; // Amarillo 
    default:
      return {}; // Sin estilo especial
  }
};

/**
 * Función para obtener propiedades anidadas de manera segura
 * 
 * @param {object} obj - Objeto del que extraer la propiedad
 * @param {string} path - Ruta hacia la propiedad separada por puntos
 * @param {any} defaultValue - Valor por defecto si no se encuentra la propiedad
 * @returns {any} Valor de la propiedad o valor por defecto
 */
export const safeGet = (obj, path, defaultValue) => {
  return path.split('.').reduce((acc, key) => {
    if (acc && acc[key] != null) {
      return acc[key];
    }
    return defaultValue;
  }, obj);
};
